import {
  ILayerQuickFilterSettings,
  OperationalSettings,
} from 'interfaces/localStorage';

import { RELEVANCES } from './date';

export const initialQuickFilterSettings: ILayerQuickFilterSettings = {
  relevance: RELEVANCES.THREE_DAYS,
  startDate: null,
  endDate: null,
};

export const initialOperationalSettings: OperationalSettings = {
  relevance: RELEVANCES.THREE_DAYS,
  startDate: null,
  endDate: null,
  gcPlacemarks: true,
  gcFrontline: true,
  fire: false,
};
